import React, { useState, useEffect, useRef } from 'react';
import { message } from 'antd';
import axios from 'axios';
import PropTypes from 'prop-types';
import { Editor } from "@tinymce/tinymce-react";
import { getAllRelatedEntity, getQueryFieldsByType } from '../../../Api/Services/ViewApiService'; // 
import { getBaseURL } from '../../../Api/ApiConfig'
// import SignaturePad from "signature_pad";

function TinyMCEEditor({ placeholder, setContent, content, edit, page, setFiles, height, selectedEntity }) {
    const attributesRef = useRef([]);
    const clickTrackUrl = process.env.REACT_APP_CLICK_URL
    const [editorPointer, setEditorPointer] = useState(null);
    const [attributesList, setAttributsList] = useState([])
    const [loadingAttributes, setLoadingAttributes] = useState(false);
    // let signaturePad = null;
    let toolbars = "";
    let location = "";
    if (page === "Email") {
        location = "bottom";
        toolbars = `undo redo | customAttachment customImage customLink |styles | backcolor forecolor | numlist bullist | indent outdent alignnone | lineheight fontfamily fontsize | hr openlink unlink | remove removeformat | cut copy paste selectall searchreplace table emoticons code fullscreen`;
    } else if (page === "Outreach") {
        location = "bottom";
        toolbars = `undo redo | customImage customLink | styles | backcolor forecolor | numlist bullist | indent outdent alignnone | lineheight fontfamily fontsize | hr openlink unlink | remove removeformat | cut copy paste selectall searchreplace table emoticons code fullscreen`;
    } else if (page === "Template") {
        location = "top";
        toolbars = `undo redo | customImage customLink | styles | backcolor forecolor | numlist bullist | indent outdent alignnone | lineheight fontfamily fontsize | hr openlink unlink | remove removeformat | cut copy paste selectall searchreplace table emoticons code fullscreen`;
    } else if (page === "Signature") {
        location = "bottom";
        toolbars = `undo redo | customImage customLink table | styles | backcolor forecolor | numlist bullist | indent outdent alignnone | lineheight fontfamily fontsize | hr openlink unlink | remove removeformat | cut copy paste selectall searchreplace emoticons code fullscreen`;
    } else if (page === "TextBox") {
        location = "bottom";
        toolbars = `undo redo | copy customLink table | styles | backcolor forecolor | numlist bullist | indent outdent alignnone | lineheight fontfamily fontsize | hr openlink unlink | remove removeformat | cut copy paste selectall searchreplace emoticons code fullscreen`;
    }
    const handleImageUpload = async (file, editor) => {
        const formData = new FormData();
        formData.append("file", file);
        try {
            const response = await axios.post(
                `${getBaseURL()}/usermgmt/uploadFile`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            editor.insertContent(
                `<img src="${response.data.mediaUrl}" alt="${response.data.mediaName}" />`
            );
        } catch (error) {
            message.error(error.response.data.message.message)
        }
    };
    const handlefileuploadChange = async (event) => {
        const files = Array.from(event.target.files);
        const filesBufferData = await Promise.all(
            files.map(async (file) => {
                const arrayBuffer = await file.arrayBuffer();
                return {
                    filename: file.name,
                    contentType: file.type,
                    size: file.size,
                    contentDisposition: "attachment",
                    content: {
                        type: "Buffer",
                        data: Array.from(new Uint8Array(arrayBuffer)),
                    },
                };
            })
        );
        setFiles((prevFiles) => [...prevFiles, ...filesBufferData]);
    };
    const uploadPastedOrDroppedImage = async (file, imgElement) => {
        const formData = new FormData();
        formData.append("file", file);

        try {
            const response = await axios.post(
                `${getBaseURL()}/usermgmt/uploadFile`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            const url = response.data.mediaUrl;
            imgElement.src = url; // ✅ replace blob/empty placeholder with real URL
        } catch (err) {
            message.error(err.response.data.message.message);
            imgElement.remove(); // clean up broken placeholder
        }
    };
    useEffect(() => {
        if (!editorPointer) return;
        const handleOutsideClick = (e) => {
            try {
                const overflowToolbar = document.querySelector('.tox-toolbar__overflow');
                if (overflowToolbar && overflowToolbar.style.display !== 'none') {
                    if (overflowToolbar.contains(e.target)) return;
                    const popupEl = document.querySelector('.tox-menu, .tox-pop');
                    if (popupEl && popupEl.contains(e.target)) return;
                    editorPointer.execCommand('ToggleToolbarDrawer', false, { skip_focus: true });
                }
            } catch (err) {
                // ignore errors silently
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        const iframeDoc = editorPointer.iframeElement?.contentDocument;
        if (iframeDoc) {
            iframeDoc.addEventListener('mousedown', handleOutsideClick);
        }
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
            if (iframeDoc) {
                iframeDoc.removeEventListener('mousedown', handleOutsideClick);
            }
        };
    }, [editorPointer]);
    const getQueryFields = async (entity) => {
        try {
            const response = await getQueryFieldsByType(entity, "Template")
            return response.data
        } catch (error) {
            message.error(error)
            return []
        }
    }
    function buildAttributes(selectedEntity, selectedAttrs, relatedEntities) {
        const result = [];
        selectedAttrs.forEach(attr => {
            result.push({
                label: `${selectedEntity}.${attr.fieldLable}`,
                value: `${selectedEntity}.${attr.filedValue}`
            });
        });
        relatedEntities.forEach(rel => {
            rel.attributes.forEach(attr => {
                result.push({
                    label: `${selectedEntity}.${rel.entity}.${attr.fieldLable}`,
                    value: `${selectedEntity}.${rel.entity}.${attr.filedValue}`
                });
            });
        });

        return result;
    }
    async function getEntityTypes(Entity) {
        try {
            setLoadingAttributes(true);
            const mainAttributes = await getQueryFields(Entity);
            const relatedResponse = await getAllRelatedEntity(Entity, "Template");
            const relatedEntities = relatedResponse || [];
            const relatedAttributesPromises = relatedEntities
                .filter(rel => rel?.entity && rel.entity.trim() !== "")
                .map(async (rel) => {
                    const attrs = await getQueryFields(rel.entity);

                    return {
                        entity: rel.entity,
                        attributes: attrs || []
                    };
                });

            const relatedAttributes = await Promise.all(relatedAttributesPromises);
            const ATTRIBUTES = buildAttributes(
                Entity,
                [
                    ...mainAttributes
                ],
                [
                    ...relatedAttributes
                ]
            );
            setAttributsList(ATTRIBUTES)
        } catch (error) {
            message.error(error)
            setAttributsList([])
        } finally {
            setLoadingAttributes(false); // ✅ stop loading
        }
    }
    useEffect(() => {
        if (selectedEntity) {
            getEntityTypes(selectedEntity)
        }
    }, [selectedEntity]);
    useEffect(() => {
        attributesRef.current = attributesList;
    }, [attributesList]);
    return (
        <>
            <Editor
                disabled={!edit || !selectedEntity}
                onInit={(evt, editorInstance) => setEditorPointer(editorInstance)}
                value={content || '<div></div>'}
                init={{
                    plugins: [
                        "fullscreen",
                        "link",
                        "lists",
                        "code",
                        "table",
                        "searchreplace",
                        "advlist",
                        "emoticons",
                        "image",
                    ],
                    placeholder,
                    toolbar: toolbars,
                    toolbar_location: location,
                    height,
                    statusbar: false,
                    branding: false,
                    menubar: false,
                    forced_root_block: 'div',

                    convert_urls: true,       // ensure conversion
                    relative_urls: false,     // force absolute URLs
                    remove_script_host: false,// keep protocol+host

                    paste_preprocess: (_, args) => {
                        if (!args.content) return;
                        args.content = args.content
                            .replace(/<\s*p(\b[^>]*)>/gi, '<div$1>')
                            .replace(/<\/\s*p\s*>/gi, '</div>');
                    },
                    mobile: {
                        theme: "silver",
                        width: "100%",
                        height: 300,
                    },
                    setup: (editor) => {
                        if (page === "Template") {
                            editor.ui.registry.addAutocompleter('attributes', {
                                trigger: '@',
                                minChars: 0,
                                columns: 1,
                                fetch: (pattern) => {
                                    if (loadingAttributes) {
                                        return Promise.resolve([
                                            {
                                                type: 'autocompleteitem',
                                                text: 'Loading...',
                                                value: '__loading__',
                                                disabled: true
                                            }
                                        ]);
                                    }
                                    // const filtered = attributesList.filter(item =>
                                    //     item.label.toLowerCase().includes(pattern.toLowerCase())
                                    // );
                                    const list = attributesRef.current;
                                    const filtered = (list || []).filter(item =>
                                        item.label.toLowerCase().includes(pattern.toLowerCase())
                                    );
                                    if (filtered.length === 0) {
                                        return Promise.resolve([
                                            {
                                                type: 'autocompleteitem',
                                                text: 'No attributes found',
                                                value: '__empty__',
                                                disabled: true
                                            }
                                        ]);
                                    }

                                    return Promise.resolve(
                                        filtered.map(item => ({
                                            type: 'autocompleteitem',
                                            text: item.label,
                                            value: item.value
                                        }))
                                    );
                                },
                                onAction: (autocompleteApi, rng, value) => {
                                    if (value === '__loading__' || value === '__empty__') return;
                                    editor.selection.setRng(rng);
                                    editor.insertContent(`{{${value}}}`);
                                    autocompleteApi.hide();
                                }
                            });
                        }
                        editor.on('keydown', (e) => {
                            if (e.key !== 'Backspace' && e.key !== 'Delete') return;

                            const sel = editor.selection;
                            const rng = sel.getRng();
                            const node = sel.getNode();

                            // Get both protected blocks
                            const protectedBlocks = [
                                editor.dom.get('ReplyContent'),
                                editor.dom.get('ForwardContent')
                            ].filter(Boolean); // ignore if not present

                            protectedBlocks.some(block => {
                                const atStart = rng.startOffset === 0;
                                const atEnd = rng.startOffset === node.textContent?.length;

                                if ((e.key === 'Backspace' && atStart && node.nextSibling === block) ||
                                    (e.key === 'Delete' && atEnd && node.previousSibling === block)) {
                                    e.preventDefault();
                                    return true; // stops .some iteration
                                }
                                return false;
                            });
                        });
                        editor.ui.registry.addButton("customLink", {
                            icon: "link",
                            tooltip: "Insert/edit link",
                            onAction: () => {
                                const { dom, selection } = editor;
                                const node = selection.getNode();

                                // 🧠 Find nearest <a> tag even if selection is inside text/div/span
                                const anchorNode = node?.nodeName === "A" ? node : dom.getParent(node, "a");

                                // Default values
                                let initialUrl = "";
                                let initialText = selection.getContent({ format: "text" }) || "";
                                let initialTitle = "";
                                let initialTrack = false;

                                // ✅ If editing an existing link
                                if (anchorNode) {
                                    const href = dom.getAttrib(anchorNode, "href");
                                    const title = dom.getAttrib(anchorNode, "title");
                                    const linkText = anchorNode.textContent?.trim() || "";

                                    if (href?.startsWith(clickTrackUrl)) {
                                        initialUrl = href.replace(clickTrackUrl, "");
                                        initialTrack = true;
                                    } else {
                                        initialUrl = href || "";
                                        initialTrack = false;
                                    }

                                    if (linkText) initialText = linkText;
                                    initialTitle = title || "";
                                }
                                // 🪟 Open custom dialog
                                editor.windowManager.open({
                                    title: anchorNode ? "Edit Link" : "Insert Link",
                                    body: {
                                        type: "panel",
                                        items: [
                                            { type: "input", name: "url", label: "URL" },
                                            { type: "input", name: "text", label: "Text to display" },
                                            { type: "input", name: "title", label: "Title" },
                                            { type: "checkbox", name: "track", label: "Add Tracking URL", classes: "small-label-checkbox" },
                                        ],
                                    },
                                    initialData: {
                                        url: initialUrl,
                                        text: initialText,
                                        title: initialTitle,
                                        track: initialTrack,
                                    },
                                    buttons: [
                                        { type: "cancel", text: "Cancel" },
                                        { type: "submit", text: anchorNode ? "Update" : "Insert", primary: true },
                                    ],

                                    onSubmit: (api) => {
                                        const data = api.getData();
                                        let finalUrl = data.url.trim();

                                        // Normalize URL
                                        if (finalUrl.startsWith("www.")) finalUrl = `https://${finalUrl}`;
                                        if (/^[a-z0-9.-]+\.[a-z]{2,}$/i.test(finalUrl) && !finalUrl.startsWith("http")) {
                                            finalUrl = `https://${finalUrl}`;
                                        }

                                        // Apply click tracking if checked
                                        if (data.track) finalUrl = clickTrackUrl + finalUrl;

                                        const linkText = data.text || finalUrl;
                                        const titleAttr = data.title?.trim() || "";

                                        if (anchorNode) {
                                            // 🛠 Update existing <a>
                                            dom.setAttrib(anchorNode, "href", finalUrl);
                                            dom.setAttrib(anchorNode, "target", "_blank");
                                            dom.setAttrib(anchorNode, "rel", "noopener noreferrer");
                                            dom.setAttrib(anchorNode, "title", titleAttr || null);
                                            dom.setHTML(anchorNode, dom.encode(linkText));
                                        } else {
                                            // 🆕 Insert new <a>
                                            const titlePart = titleAttr ? ` title="${titleAttr}"` : "";
                                            const html = `<a href="${finalUrl}"${titlePart} target="_blank" rel="noopener noreferrer">${linkText}</a>`;
                                            editor.insertContent(html);
                                        }

                                        api.close();
                                    },
                                });
                            },
                        });
                        // Replace the default link button with your version
                        editor.ui.registry.addButton("link", {
                            icon: "link",
                            tooltip: "Insert/edit link",
                            onAction: () => editor.execCommand("customLink"),
                        });
                        // Custom Image Button
                        editor.ui.registry.addIcon(
                            'attachmentIcon',
                            `<svg viewBox="0 0 24 24" height="24" width="20" focusable="false"
        stroke="currentColor" stroke-width="2"
        fill="none" stroke-linecap="round" stroke-linejoin="round">
      <path fill="none" 
        d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
  </svg>`
                        );
                        editor.ui.registry.addButton("customImage", {
                            icon: "image",
                            tooltip: "Insert Image",
                            onAction: () => {
                                const input = document.createElement("input");
                                input.type = "file";
                                input.accept = "image/*";
                                input.onchange = (e) => {
                                    const file = e.target.files[0];
                                    if (file) {
                                        handleImageUpload(file, editor)
                                    }
                                };
                                input.click();
                            },
                        });
                        // Custom Attachment Button
                        editor.ui.registry.addButton("customAttachment", {
                            icon: "attachmentIcon",
                            tooltip: "Insert Attachment",
                            onAction: () => {
                                const input = document.createElement("input");
                                input.type = "file";
                                input.accept = "*";
                                input.multiple = true;
                                input.onchange = async (event) => {
                                    handlefileuploadChange(event)
                                };
                                input.click();
                            },
                        });
                        editor.on("Paste PostProcess", () => {
                            const imgs = editor.getBody().querySelectorAll("img[src^='blob:']");
                            imgs.forEach(async (img) => {
                                if (img.dataset.uploaded) return;
                                img.dataset.uploaded = "true";
                                const blob = await fetch(img.src).then((r) => r.blob());
                                const ext = blob.type.split("/")[1] || "png";
                                const fileName = blob.name || `pasted-${Date.now()}.${ext}`;
                                const file = new File([blob], fileName, { type: blob.type });
                                uploadPastedOrDroppedImage(file, img);
                            });
                        });
                        editor.on("Drop", (event) => {
                            const { files } = event.dataTransfer;
                            if (files.length > 0) {
                                event.preventDefault();
                                Array.from(files).forEach((file) => {
                                    const tempId = `upload-${Date.now()}`;
                                    editor.insertContent(`<img id="${tempId}" src="" />`);
                                    const imgElement = editor.getBody().querySelector(`#${tempId}`);
                                    if (imgElement) {
                                        uploadPastedOrDroppedImage(file, imgElement);
                                    }
                                });
                            }
                        });
                    },
                }}
                onEditorChange={(content) => {
                    setContent(content);
                }} />
        </>
    );
};
TinyMCEEditor.propTypes = {
    setContent: PropTypes.func.isRequired,
    setFiles: PropTypes.func.isRequired,
    content: PropTypes.string.isRequired,
    edit: PropTypes.bool.isRequired,
    placeholder: PropTypes.string,
    page: PropTypes.string.isRequired,
    selectedEntity: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
};
export default TinyMCEEditor;
